import DomainIcon from "./icons/Buildings";
import _isNil from "lodash/isNil";

const statusToColor = (status?: string) => {
  switch (status) {
    case "COMPLETED":
      return "secondary";
    case "FAILED":
      return "error";
    default:
      return undefined;
  }
};

export const JDBCTask = ({ nodeData }: { nodeData: Element | any }) => {
  const { task } = nodeData;

  return _isNil(task?.executionData?.domain) ? null : (
    <div style={{ marginTop: "8px" }}>
      <div
        style={{
          backgroundColor: statusToColor(task.executionData.status),
          padding: "2px",
        }}
      >
        <span className="chip-avatar">
          <DomainIcon size={14} color={"white"} />
        </span>
        <span className="chip-label">{task.executionData.domain}</span>
      </div>
    </div>
  );
};
